import { SmartConnectorProvider } from './SmartConnectorProvider';
import { StyledFullscreenModal } from './styles';
import { Header } from './Header';
import { SubNavigation } from './SubNavigation';
import { Steps } from './steps';
import { ConfirmationManager } from './ConfirmationManager';
import { useEndsOfYScroll } from '__components/Kizen/LazyLoad/helpers';
import { useRef } from 'react';

export const SmartConnectorWizardPage = () => {
  const bodyRef = useRef<HTMLDivElement>(null);
  const [scrolledTop] = useEndsOfYScroll(bodyRef, []);

  return (
    <SmartConnectorProvider>
      <StyledFullscreenModal
        ref={bodyRef}
        show
        enforceFocus={false}
        header={<Header scrolledTop={scrolledTop} />}
        scrolledTop={scrolledTop}
      >
        <SubNavigation />
        <Steps />
      </StyledFullscreenModal>
      <ConfirmationManager />
    </SmartConnectorProvider>
  );
};
